
<div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
  <div class="w-full max-w-md">
    <!-- <div class="flex mb-6 shadow-sm">
      <button class="tab-btn active-success" onclick="show('success')" id="tab-success">✓ Success</button>
      <button class="tab-btn" onclick="show('failed')"  id="tab-failed">✕ Failed</button>
      <button class="tab-btn" onclick="show('pending')" id="tab-pending">⏱ Pending</button>
    </div> -->
    <div *ngIf="activeTab === 'COMPLETED'" id="view-success" class="card-enter">
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div class="bg-green-50 px-6 pt-8 pb-6 text-center border-b border-green-100">
          <div class="animate-pop w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4 border-4 border-green-200">
            <svg class="w-9 h-9 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <p class="text-green-700 text-sm font-semibold uppercase tracking-widest mb-1">Payment Successful</p>
          <p class="text-3xl font-semibold text-gray-900">₹{{transactionDetails.amount}}</p>
          <p class="text-sm text-gray-500 mt-1">Your subscription has been activated</p>
        </div>
        <div class="px-6 py-2">
          <div class="detail-row">
            <span class="text-gray-500">Transaction ID</span>
            <span class="mono text-xs text-gray-800 bg-gray-50 px-2 py-1 rounded">{{transactionDetails.transactionId ?? '-'}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Payment method</span>
            <span class="flex items-center gap-1.5 font-medium text-gray-800">
              <!-- <span class="w-5 h-5 rounded-full bg-indigo-600 flex items-center justify-center">
                <svg class="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M2 7h20v10H2z"/></svg>
              </span> -->
              {{transactionDetails.paymentMode}}
            </span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Date & time</span>
            <span class="font-medium text-gray-800">{{transactionDetails.timestamp | date:'dd MMM yyyy, hh:mm a'}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Plan</span>
            <span class="font-medium text-gray-800">{{transactionData.name ?? 'Pro'}} — {{transactionData.duration}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Status</span>
            <span class="flex items-center gap-1.5 bg-green-50 text-green-700 text-xs font-semibold px-3 py-1 rounded-full border border-green-200">
              <span class="w-1.5 h-1.5 bg-green-500 rounded-full"></span> {{transactionDetails.status}}
            </span>
          </div>
        </div>

        <!-- Actions -->
        <div class="px-6 pb-6 pt-2 flex flex-col gap-2">
          <button (click)="gotoProperty()" class="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-xl transition-all text-sm">
            Go to Property
          </button>
          <button (click)="downloadReceipt()" class="w-full border border-gray-200 hover:bg-gray-50 text-gray-700 font-medium py-3 rounded-xl transition-all text-sm flex items-center justify-center gap-2">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
            </svg>
            Download Receipt
          </button>
        </div>
      </div>
    </div>

    <!-- ───── FAILED ───── -->
    <div *ngIf="activeTab === 'FAILED'"  id="view-failed" class="card-enter">
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">

        <div class="bg-red-50 px-6 pt-8 pb-6 text-center border-b border-red-100">
          <div class="animate-pop w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4 border-4 border-red-200">
            <svg class="w-9 h-9 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <p class="text-red-700 text-sm font-semibold uppercase tracking-widest mb-1">Payment Failed</p>
          <p class="text-3xl font-semibold text-gray-900">₹{{transactionDetails.amount}}</p>
          <p class="text-sm text-gray-500 mt-1">Your payment could not be processed</p>
        </div>

        <!-- Warning banner -->
        <div class="mx-6 mt-4 bg-red-50 border border-red-100 rounded-xl p-3 flex gap-3 items-start">
          <svg class="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
          </svg>
          <p class="text-xs text-red-700 leading-relaxed">Transaction declined by your bank. No amount has been deducted from your account.</p>
        </div>

        <div class="px-6 py-2 mt-2">
          <div class="detail-row">
            <span class="text-gray-500">Transaction ID</span>
            <span class="mono text-xs text-gray-800 bg-gray-50 px-2 py-1 rounded">{{transactionDetails.transactionId}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Payment method</span>
            <span class="font-medium text-gray-800">{{transactionDetails.paymentMode}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Date & time</span>
            <span class="font-medium text-gray-800">{{transactionDetails.timestamp | date:'dd MMM yyyy, hh:mm a'}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Reason</span>
            <span class="font-medium text-red-600 text-sm">Insufficient funds</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Status</span>
            <span class="flex items-center gap-1.5 bg-red-50 text-red-700 text-xs font-semibold px-3 py-1 rounded-full border border-red-200">
              <span class="w-1.5 h-1.5 bg-red-500 rounded-full"></span> {{transactionDetails.status}}
            </span>
          </div>
        </div>

        <div class="px-6 pb-6 pt-2 flex flex-col gap-2">
          <button class="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-xl transition-all text-sm">
            Retry Payment
          </button>
          <button class="w-full border border-gray-200 hover:bg-gray-50 text-gray-700 font-medium py-3 rounded-xl transition-all text-sm">
            Contact Support
          </button>
        </div>
      </div>
    </div>

    <!-- ───── PENDING ───── -->
    <div *ngIf="activeTab === 'PENDING'" id="view-pending" class="card-enter">
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">

        <div class="bg-amber-50 px-6 pt-8 pb-6 text-center border-b border-amber-100">
          <div class="w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4 border-4 border-amber-200 relative">
            <svg class="w-9 h-9 text-amber-600 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"/>
            </svg>
          </div>
          <p class="text-amber-700 text-sm font-semibold uppercase tracking-widest mb-1">Payment Pending</p>
          <p class="text-3xl font-semibold text-gray-900">₹{{transactionDetails.amount}}</p>
          <p class="text-sm text-gray-500 mt-1">Waiting for confirmation from your bank</p>
        </div>

        <!-- Info banner -->
        <div class="mx-6 mt-4 bg-amber-50 border border-amber-100 rounded-xl p-3 flex gap-3 items-start">
          <svg class="animate-pulse w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
          </svg>
          <p class="text-xs text-amber-800 leading-relaxed">This usually takes 1–3 minutes. Please do <strong>not</strong> close this page or retry the payment.</p>
        </div>

        <!-- Progress bar -->
        <div class="mx-6 mt-4">
          <div class="flex justify-between text-xs text-gray-400 mb-1.5">
            <span>Processing</span>
            <span>Verifying</span>
            <span>Complete</span>
          </div>
          <div class="h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div class="h-full w-1/2 bg-amber-400 rounded-full animate-pulse"></div>
          </div>
        </div>

        <div class="px-6 py-2 mt-2">
          <div class="detail-row">
            <span class="text-gray-500">Transaction ID</span>
            <span class="mono text-xs text-gray-800 bg-gray-50 px-2 py-1 rounded">{{transactionDetails.transactionId?? '_'}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Payment method</span>
            <span class="font-medium text-gray-800">{{transactionDetails.paymentMode}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Date & time</span>
            <span class="font-medium text-gray-800">{{transactionDetails.timestamp | date:'dd MMM yyyy, hh:mm a'}}</span>
          </div>
          <div class="detail-row">
            <span class="text-gray-500">Status</span>
            <span class="flex items-center gap-1.5 bg-amber-50 text-amber-700 text-xs font-semibold px-3 py-1 rounded-full border border-amber-200">
              <span class="w-1.5 h-1.5 bg-amber-400 rounded-full animate-pulse"></span> {{transactionDetails.status}}
            </span>
          </div>
        </div>

        <div class="px-6 pb-6 pt-2 flex flex-col gap-2">
          <button class="w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold py-3 rounded-xl transition-all text-sm">
            Check Status
          </button>
          <button class="w-full border border-gray-200 hover:bg-gray-50 text-gray-700 font-medium py-3 rounded-xl transition-all text-sm">
            Go Back to Home
          </button>
        </div>
      </div>
    </div>

  </div>